import { StyleSheet, View, Image, Text, TouchableOpacity, ImageBackground } from 'react-native';
import { useEffect, useState } from "react";
import AsyncStorage from "@react-native-async-storage/async-storage";

            



const Drinks = [
    {
        img: require('../assets/screens/1-q.png'),
        img2: require('../assets/screens/1-w.png'),
    },
    {
        img: require('../assets/screens/2-q.png'),
        img2: require('../assets/screens/2-w.png'),
    },
    {
        img: require('../assets/screens/3-q.png'),
        img2: require('../assets/screens/3-w.png'),
    },
    {
        img: require('../assets/screens/4-q.png'),
        img2: require('../assets/screens/4-w.png'),
    },
    {
        img: require('../assets/screens/5-q.png'),
        img2: require('../assets/screens/5-w.png'),
    },
    {
        img: require('../assets/screens/6-q.png'),
        img2: require('../assets/screens/6-w.png'),
    },
    ]

const OkScreen = ({ onOpen, selectedNo}: {
    onOpen(): void,
  selectedNo: number,}) => {
  
  const selectDrink = Drinks[selectedNo -1];;
  return <View style={styles.container}>
      <View  style={{...styles.logoW, backgroundColor: '#099b43'}}>

      <Image
        style={styles.logo}
        resizeMode="contain"
        resizeMethod="resize"
        source={require('../assets/logo.png')}
      />
    </View>
    <View  style={styles.containerQuiz}>

<View style={styles.quizView}>
    <View style={styles.imgInfo}>
<Image
             style={styles.imgInfoAbsolute}
             resizeMode="contain"
             resizeMethod="auto"
             source={selectDrink.img2}
           />

</View>
<View style={styles.quizAnswer}>

<Image
            resizeMode="contain"
            style={{
              width: 407,
              height: 483,
            }}
             resizeMethod="auto"
             source={require('../assets/felicitari.png')}
           />
</View>


</View>

    </View>
    <View  style={styles.containerLast}>
      <View>
           <TouchableOpacity
          style={styles.button}
          onPress={() => {
            onOpen();
          }}
        >
          <Text style={styles.buttonText}>RESTART</Text>
        </TouchableOpacity>
  </View>

        <Image
           style={{
            ...styles.centerImage,
          height: 74,
            width: 627
          }}
          resizeMode="contain"
          resizeMethod="resize"
          source={require('../assets/cups.png')}
        />
  
    </View>
  </View>
}

const styles = StyleSheet.create({
    container: {
      width:'100%',
      minHeight:1080,
      backgroundColor: '#b8cd70',
    },
    containerQuiz:{
        flex:1,
      width: '100%',
        minHeight:700,
        backgroundColor: '#fff',
    },
  logoW: {
paddingBottom: 10,   
  
        },
          logo:{
     alignSelf: 'center',
    width: 800,
    height:126,
    },
    containerw:{
      position:'relative',
      width:'100%',
      zIndex: 1,
    },
   
    centerImage:{
      alignSelf: 'center',
    },
    imgInfo:{
        height: 650,
        position: 'relative',
        marginLeft: '10%',
      width: 300,
        zIndex: 1,
    },
    imgInfoAbsolute:{
      height: 784,
      width:256,
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 10,
    },
    quizView:{
        alignItems:'flex-start',
        flex:1,
        marginTop: '8%',
        marginBottom: 18,
        flexDirection: 'row',
      },
      quizAnswer:{
        width:'60%',
        flex: 1,
        height: 520,
        padding: 10,
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 80,
        marginRight: 90,
      },
    containerLast:{
         width:'100%',
         zIndex: 2,
         position:'relative',
         flexDirection: 'column',
         marginTop: '10%',
     },
     button:{
        backgroundColor:'#00a547',
        borderRadius: 7,
        alignSelf: 'center',
        flex:1,
        width:280,
        height: 60,
        lineHeight: 50,
        marginTop:'12%',
        marginBottom:'10%',
        alignItems:'center',
        justifyContent:'center',
      },
      buttonText:{
        fontSize: 42,
        color: '#fff',
        fontWeight: 'bold',
        alignSelf: 'center',
        paddingBottom:'0%',
        lineHeight: 50,
        marginBottom:'1%',
        fontFamily: 'Agriculture',
      },
  });
  export default  OkScreen;
  